export default __webpack_public_path__ + "assets/YC-logo-black.a20b016a.png";